import React from "react";
import { useTranslations } from "next-intl";
import { Button } from "@/components/common";

type TProps = {
  onSubmit: (term: boolean) => void;
  productPrice: number;
};

const ParcelGuaranteeGeModal = ({ onSubmit, productPrice }: TProps) => {
  const t = useTranslations();

  const insuranceCost = ((productPrice - 300) * 0.0299).toFixed(2);

  return (
    <div className="py-6">
      <h2>{t("additionalInsuranceTitle")}</h2>
      <p>
        {t("additionalInsuranceDescription", { amount: `${insuranceCost}$` })}
      </p>
      <div className="mt-4 flex flex-col gap-4">
        <Button
          onClick={() => {
            onSubmit(true);
          }}
        >
          {t("pay")}
        </Button>
        <Button
          onClick={() => {
            onSubmit(false);
          }}
          variant="outlined-dash"
        >
          {t("leaveBasicInsurance")}
        </Button>
      </div>
    </div>
  );
};

export default ParcelGuaranteeGeModal;
